module.exports = __webpack_public_path__ + "static/media/assess.bcb39651.gif";